<template>
  <div class="card-table-row border-bottom-0 px-i">
    <div class="card-table-row-start">
      <div class="card-table-row-start-text">
        {{ item.email }}
      </div>
      <div v-if="item.verified" class="card-table-row-start-check">
        <i class="demo-icon icon-check" />
      </div>
    </div>
    <div class="card-table-row-end">
      <router-link :to="{ name: 'Edit User Email', params: {
                     userId: user.id,
                     id: item.id }
                   }"
                   class="card-table-row-end-icon">
        <i class="demo-icon icon-chevron-right" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { ElementMixin, HandleDirective } from "vue-slicksort";

export default {
  name: "SortableEmail",
  directives: { handle: HandleDirective },
  mixins: [ElementMixin],
  props: ["item", "user"]
};
</script>
